/***********************************************************
 * Copyright 2010 Adobe Systems Incorporated.  All Rights Reserved.
 *
 * *********************************************************
 *  The contents of this file are subject to the Berkeley Software Distribution (BSD) Licence
 *  (the "License"); you may not use this file except in
 *  compliance with the License.
 *
 * Software distributed under the License is distributed on an "AS IS"
 * basis, WITHOUT WARRANTY OF ANY KIND, either express or implied. See the
 * License for the specific language governing rights and limitations
 * under the License.
 *
 *
 * The Initial Developer of the Original Code is Adobe Systems Incorporated.
 * Portions created by Adobe Systems Incorporated are Copyright (C) 2010 Adobe Systems
 * Incorporated. All Rights Reserved.
 *
 **********************************************************/

(function ($) {
	var JVideoPlayerPlugin = function (parent, options) {
		var defaults = {
			id: "jVideoPlayback",
			src: "http://localhost:5080/jVideo/output/question1.mp4",
			autoPlay: true,
			controlBarAutoHide: true,
			controlBarMode: "none",
			javascriptCallbackFunction: "jQuery('#" + parent.id + "').data('JVideoPlayer').onJSBridgeCreated",
			wmode: "transparent"
		};

		var JVideoPlayer = this;
		JVideoPlayer.parent = $(parent);
		JVideoPlayer.parentID = parent.id;
		JVideoPlayer.options = $.extend({}, defaults, options);

		if (typeof JVideoPlayer.players === 'undefined') {
			JVideoPlayer.players = {};
		}

		JVideoPlayer.initializeControlBar = function() {
			$(".jVPlayer-volume").slider({
				orientation: 'vertical',
				range: "min",
				min: 0,
				max: 100.0,
				value: 100.0,
				animate: true
			});

			$(".jVPlayer-progress").slider({
				orientation: 'horizontal',
				range: "min",
				max: 100.0,
				value: 0.0,
				step: 0.01,
				animate: true
			});
		};

		JVideoPlayer.formatTimeStatus = function(currentPosition, totalDuration) {
			var h;
			var m;
			var s;

			function prettyPrintSeconds(seconds, leadingMinutes, leadingHours) {
				seconds = Math.ceil(isNaN(seconds) ? 0 : Math.max(0, seconds));
				h = Math.floor(seconds / 3600);
				m = Math.floor(seconds % 3600 / 60);
				s = seconds % 60;
				return ((h > 0 || leadingHours) ? (h + ":") : "") + (((h > 0 || leadingMinutes) && m < 10) ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
			}

			var totalDurationString = prettyPrintSeconds(totalDuration);
			var currentPositionString = prettyPrintSeconds(currentPosition, h > 0 || m > 9, h > 0);
			return currentPositionString + " / " + totalDurationString;
		};

		JVideoPlayer.unbindAll = function() {
			var id = JVideoPlayer.options.id;
			var player = document.getElementById(id);
			var instance = JVideoPlayer.players[id];

			if (instance !== undefined) {
				instance.play.unbind();
				instance.progress.unbind();
				instance.mute.unbind();
				instance.volume.unbind();
				instance.fullScreen.unbind();
			}
		};

		JVideoPlayer.StrobeMediaPlaybackJSUI = function(player, controlBar) {
			this.currentTime = 0;
			this.player = player;
			this.controlBar = controlBar;
			//Play Button
			this.play = $('.jVPlayer-play', this.controlBar);
			//Mute/Unmute button
			this.mute = $('.jVPlayer-mute', this.controlBar);
			//Volume Slider
			this.volume = $('.jVPlayer-volume', this.controlBar);
			//Display the time.
			this.time = $('.jVPlayer-time', this.controlBar);
			//Progress Bar
			this.progress = $('.jVPlayer-progress', this.controlBar);
			//Fullscreen button
			this.fullScreen = $('.jVPlayer-fullScreen', this.controlBar);
			//Flag to check if the instance is html5 capable or not. Can it play HTML5 mp4
			this.html5 = false;
			//Flag to indicate if the video is fullscreen or not.
			this.isFullscreen = false;

			//Binding events etc.
			//Play/Pause
			this.play.bind('click', this, this.onPlayClick);
			//Scrubbing
			this.progress.bind('slide', this, this.onProgressSlide);
			//Seek
			this.progress.bind('change', this, this.onProgressSlide);
			//Mute/Unmute
			this.mute.bind('click', this, this.onMuteClick);
			//Volume Scrubbing
			this.volume.bind('slide', this, this.onVolumeSlide);
			//Volume Change
			this.volume.bind('change', this, this.onVolumeSlide);
			this.fullScreen.bind('click', this, this.onFullScreen);

			document.addEventListener("fullscreenchange", function () {
				var id = JVideoPlayer.options.id;
				var player = JVideoPlayer.players[id];

				if (document.fullScreen) {
					_gaq.push(['_trackEvent', 'Playback', 'Enter-FullScreen']);
					$('.jVPlayer-controls').addClass('fullscreen');
					player.isFullscreen = true;
				} else {
					_gaq.push(['_trackEvent', 'Playback', 'Exit-FullScreen']);
					$('.jVPlayer-controls').removeClass('fullscreen');
					player.isFullscreen = false;
				}
			}, false);

			document.addEventListener("mozfullscreenchange", function () {
				var id = JVideoPlayer.options.id;
				var player = JVideoPlayer.players[id];

			    if(document.mozFullScreen) {
			    	_gaq.push(['_trackEvent', 'Playback', 'Mozilla-Enter-FullScreen']);
			    	$('.jVPlayer-controls').addClass('fullscreen');
			    	player.isFullscreen = true;
			    } else {
			    	_gaq.push(['_trackEvent', 'Playback', 'Mozilla-Exit-FullScreen']);
			    	$('.jVPlayer-controls').removeClass('fullscreen');
			    	player.isFullscreen = false;
			    }
			}, false);

			document.addEventListener("webkitfullscreenchange", function () {
				var id = JVideoPlayer.options.id;
				var player = JVideoPlayer.players[id];

			    if(document.webkitIsFullScreen) {
			    	_gaq.push(['_trackEvent', 'Playback', 'Webkit-Enter-FullScreen']);
			    	$('.jVPlayer-controls').addClass('fullscreen');
			    	//JVideoPlayer.videoTag.width = "100%";
			    	player.isFullscreen = true;
			    } else {
			    	_gaq.push(['_trackEvent', 'Playback', 'Webkit-Exit-FullScreen']);
			    	$('.jVPlayer-controls').removeClass('fullscreen');
			    	player.isFullscreen = false;
			    }
			}, false);
		};

		JVideoPlayer.StrobeMediaPlaybackJSUI.prototype = {
			onDurationChangeHTML5: function() {
				_gaq.push(['_trackEvent', 'Playback', 'DurationChangeHTML5']);
				var id = JVideoPlayer.options.id;
				var player = JVideoPlayer.players[id];
				$(player.time).html(JVideoPlayer.formatTimeStatus(player.player.currentTime, player.player.duration));
				$(".jVPlayer-progress").slider({
					max: player.player.duration,
					value: Math.max(0, player.player.currentTime)
				});
			},

			onTimeUpdateHTML5: function() {
				var id = JVideoPlayer.options.id;
				var player = JVideoPlayer.players[id];
				$(player.time).html(JVideoPlayer.formatTimeStatus(this.currentTime, this.duration));
				$(player.progress).slider({
					max: this.duration,
					value: Math.max(0, this.currentTime)
				});
			},

			onEndedHTML5: function() {
				_gaq.push(['_trackEvent', 'Playback', 'EndedHTML5']);
				var id = JVideoPlayer.options.id;
				var player = JVideoPlayer.players[id];
				$(player.time).html(JVideoPlayer.formatTimeStatus(0, this.duration));
				$(".jVPlayer-progress").slider({
					max: this.duration,
					value: Math.max(0, 0)
				});
				player.play.removeClass('jVideo-paused-button');
			},

			onDurationChange: function(duration) {
				_gaq.push(['_trackEvent', 'Playback', 'DurationChange']);
				this.duration = duration;
				$(this.time).html(JVideoPlayer.formatTimeStatus(this.currentTime, this.duration));
				$(".jVPlayer-progress").slider({
					max: this.duration,
					value: Math.max(0, this.currentTime)
				});
			},

			onCurrentTimeChange: function(currentTime) {
				this.currentTime = currentTime;
				$(this.time).html(JVideoPlayer.formatTimeStatus(currentTime, this.duration));

				this.progress.slider({
					max: this.duration,
					value: Math.max(0, currentTime)
				});
			},

			onComplete: function(val) {
				var id = JVideoPlayer.options.id;
				var player = JVideoPlayer.players[id];
				player.stop2();
			},

			//Event to handle volume change from HTML5 and Flash.
			onVolumeChange: function(value) {
				if (JVideoPlayer.html5) {
					_gaq.push(['_trackEvent', 'Playback', 'VolumeChangeHTML5']);
					var id = JVideoPlayer.options.id;
					var player = JVideoPlayer.players[id];
					//hacky here. Because volumechange event gets fired when .muted is set
					//to true. But then the volume property does not reflect that. As a
					//result, if the video is muted, then set the volume slider to 0.
					if (this.muted) {
						player.volume.slider("value", 0);
					} else {
						player.volume.slider("value", this.volume * 100.0);
					}

				} else {
					_gaq.push(['_trackEvent', 'Playback', 'VolumeChange']);
					this.volume.slider("value", value * 100.0);
				}
			},

			onMutedChange: function(value) {
				_gaq.push(['_trackEvent', 'Playback', 'onMutedChange', value]);
				if (value === false) // Seems to be a BUG?
				{
					this.mute.button('option', {
						icons: {
							primary: 'ui-icon-volume-on'
						}
					});
				} else {
					this.mute.button('option', {
						icons: {
							primary: 'ui-icon-volume-off'
						}
					});
				}
			},

			onMediaPlayerStateChange: function(value) {
				_gaq.push(['_trackEvent', 'Playback', 'MediaPlayerStateChange', value]);
				var options;
				if (value == 'playing') {
					this.play.addClass('jVideo-paused-button');
				} else if (value == 'paused' || value == 'ready') {
					this.play.removeClass('jVideo-paused-button');
				}
			},

			onPlayClick: function(event) {
				if (JVideoPlayer.html5) {
					var videoTag = JVideoPlayer.videoTag;
					if (videoTag.paused) {
						_gaq.push(['_trackEvent', 'Playback', 'PlayHTML5']);
						videoTag.play();
						JVideoPlayer.players[JVideoPlayer.options.id].play.addClass('jVideo-paused-button');
					} else {
						_gaq.push(['_trackEvent', 'Playback', 'PauseHTML5']);
						videoTag.pause();
						JVideoPlayer.players[JVideoPlayer.options.id].play.removeClass('jVideo-paused-button');
					}
				} else {
					var player = event.data.player;
					var state = player.getState();
					if (state == 'playing') {
						_gaq.push(['_trackEvent', 'Playback', 'PauseFlash']);
						player.pause();
					} else if (state == 'paused' || state == 'ready') {
						_gaq.push(['_trackEvent', 'Playback', 'PlayFlash']);
						player.play2();
					}
				}
			},

			onPlay: function(event)  {
				var videoTag = JVideoPlayer.videoTag;
				if (videoTag.paused) {
					JVideoPlayer.players[JVideoPlayer.options.id].play.removeClass('jVideo-paused-button');
				} else {
					JVideoPlayer.players[JVideoPlayer.options.id].play.addClass('jVideo-paused-button');
				}
			},

			onProgressSlide: function(event, ui) {
				var player = event.data.player;
				var seekValue = ui.value;
				if (JVideoPlayer.html5) {
					_gaq.push(['_trackEvent', 'Playback', 'SeekHTML5', 'Percentage', Math.ceil((seekValue/(player.duration))*100)]);
					player.currentTime = seekValue;
				} else {
					_gaq.push(['_trackEvent', 'Playback', 'SeekFlash']);
					if (event.originalEvent !== undefined) {
						if (player.getState() != "ready" && player.canSeekTo(seekValue)) {
							player.seek(seekValue);
						} else {
							return false;
						}
					}
				}
				return true;
			},

			onVolumeSlide: function(event, ui) {
				var player = event.data.player;
				if (JVideoPlayer.html5) {
					_gaq.push(['_trackEvent', 'Playback', 'VolumeChangeHTML5', Math.ceil(ui.value/100)]);
					player.volume = ui.value/100.0;
				} else {
					_gaq.push(['_trackEvent', 'Playback', 'VolumeChangeFlash', Math.ceil(ui.value/100)]);
					player.setVolume(ui.value / 100.0);
				}
			},

			onMuteClick: function(event) {
				var player = event.data.player;
				if (JVideoPlayer.html5) {
					_gaq.push(['_trackEvent', 'Playback', 'muteHTML5', player.muted]);
					player.muted = !player.muted;
				} else {
					_gaq.push(['_trackEvent', 'Playback', 'muteFlash', player.getMuted()]);
					player.setMuted(!player.getMuted());
				}
			},

			onFullScreen: function(event) {
				var id = JVideoPlayer.options.id;
				var player = JVideoPlayer.players[id];
				var element = document.getElementById('jVideoPlayback');
				if (player.isFullscreen === false) {
					if(element.requestFullScreen) {
					  element.requestFullScreen();
					} else if(element.webkitRequestFullScreen ) {
					  element.webkitRequestFullScreen();
					} else if(element.mozRequestFullScreen) {
					  element.mozRequestFullScreen();
					}
				} else {
					if(document.cancelFullScreen) {
					  document.cancelFullScreen();
					} else if(document .webkitCancelFullScreen ) {
					  document.webkitCancelFullScreen();
					} else if(document .mozCancelFullScreen) {
					  document.mozCancelFullScreen();
					}
				}
			}

		};

		JVideoPlayer.registerswfetc = function() {
			JVideoPlayer.html5 = false;
			// Embed the player SWF:
			swfobject.embedSWF(JVideoPlayer.options.flashSrc, JVideoPlayer.options.id, JVideoPlayer.options.width, JVideoPlayer.options.height, "12.0.0", "/__assets__/scripts/common/video/expressInstall.swf", JVideoPlayer.options, {
				allowFullScreen: "true",
				wmode: "opaque"
			}, {
				name: JVideoPlayer.options.id
			});
		};

		JVideoPlayer.deregisterswf = function() {
			var element = document.getElementById(JVideoPlayer.options.id);
			if (element) {
				var div = document.createElement("div");
				element.parentNode.insertBefore(div, element);
				//Remove the SWF
				swfobject.removeSWF(JVideoPlayer.options.id);
				//Assign the new DIV to the old element's ID
				div.setAttribute("id", JVideoPlayer.options.id);
			}
		};

		var player = null;

		JVideoPlayer.onJSBridgeCreated = function(id) {
			if (player === null) {
				player = document.getElementById(id);
				JVideoPlayer.players[id] = new JVideoPlayer.StrobeMediaPlaybackJSUI(player, $("#" + id + "ControlBar"));

				var instance = JVideoPlayer.players[id];
				var instanceName = "JVideoPlayer.players['" + id + "']";
				var jQueryInstanceName = "jQuery('#" + JVideoPlayer.parentID + "').data('JVideoPlayer').players['" + id + "']";

				for (var name in instance) {
					if (name.indexOf('on') === 0) {
						var eventName = name.charAt(2).toLowerCase() + name.substring(3);
						player.addEventListener(eventName, jQueryInstanceName + "." + name);
					}
				}
			}
		};

		//TODO-Pranav: Removed this code because now it should not be used. Fixes an issue with Firefox too.

		// JVideoPlayer.onJSBridgeRemoved = function() {
		// 	var id = JVideoPlayer.options.id;
		// 	var player = document.getElementById(id);
		// 	var instance = JVideoPlayer.players[id];
		// 	var instanceName = "JVideoPlayer.players['" + id + "']";
		// 	var jQueryInstanceName = "jQuery('#" + JVideoPlayer.parentID + "').data('JVideoPlayer').players['" + id + "']";
		// 	JVideoPlayer.unbindAll();
		// 	for (var name in instance) {
		// 		if (name.indexOf('on') === 0) {
		// 			var eventName = name.charAt(2).toLowerCase() + name.substring(3);
		// 			player.removeEventListener(eventName, jQueryInstanceName + "." + name);
		// 		}
		// 	}
		// 	JVideoPlayer.players[id] = undefined;
		// };

		JVideoPlayer.createVideoTag = function() {
			var videoTag = document.createElement('video');
			videoTag.width = JVideoPlayer.options.width;
			videoTag.height = JVideoPlayer.options.height;
			$("#"+JVideoPlayer.options.id).replaceWith(videoTag);
			var id = JVideoPlayer.options.id;
			videoTag.id = id;
			videoTag.addEventListener('loadedmetadata', function() {
				JVideoPlayer.players[id] = new JVideoPlayer.StrobeMediaPlaybackJSUI(videoTag, $("#" + id + "ControlBar"));
				var player = jQuery('#' + JVideoPlayer.parentID).data('JVideoPlayer').players[id];
				videoTag.addEventListener('durationchange', player.onDurationChangeHTML5);
				videoTag.addEventListener('timeupdate', player.onTimeUpdateHTML5);
				videoTag.addEventListener('ended', player.onEndedHTML5);
				videoTag.addEventListener('volumechange', player.onVolumeChange);
				videoTag.addEventListener('playing', player.onPlay);
				player.onDurationChangeHTML5();
				player.onPlay();

			}, false);

			for (var i=0; i < JVideoPlayer.options.src.length; i++) {
				let url = JVideoPlayer.options.src[i];
				if (videoTag.canPlayType('video/mp4') && (url.indexOf(".mp4") !== -1)) {
					_gaq.push(['_trackEvent', 'Playback', 'mp4PlaybackHTML5']);
					videoTag.src = url;
					break;
				} else if (videoTag.canPlayType('video/webm') && (url.indexOf(".webM") !== -1)) {
					_gaq.push(['_trackEvent', 'Playback', 'webMPlaybackHTML5']);
					videoTag.src = url;
					break;
				}
			}
			videoTag.autoplay = JVideoPlayer.options.autoplay || JVideoPlayer.options.videoAutoPlay;
			JVideoPlayer.html5 = true;
			JVideoPlayer.videoTag = videoTag;
			videoTag.load();
		};

		JVideoPlayer.removeEventsHTML5 = function() {
			_gaq.push(['_trackEvent', 'Playback', 'removeEventsHTML5']);
			var id = JVideoPlayer.options.id;
			var videoTag = document.getElementById(JVideoPlayer.options.id);
			JVideoPlayer.players[id] = new JVideoPlayer.StrobeMediaPlaybackJSUI(videoTag, $("#" + id + "ControlBar"));
			var player = jQuery('#' + JVideoPlayer.parentID).data('JVideoPlayer').players[id];
			videoTag.removeEventListener('durationchange', player.onDurationChangeHTML5);
			videoTag.removeEventListener('timeupdate', player.onTimeUpdateHTML5);
			videoTag.removeEventListener('ended', player.onEndedHTML5);
			videoTag.removeEventListener('volumechange', player.onVolumeChange);
			videoTag.removeEventListener('playing', player.onPlay);
			JVideoPlayer.players[JVideoPlayer.options.id].play.removeClass('jVideo-paused-button');
		};

		JVideoPlayer.initializeControlBar();

		if (options.src[0].split('.').pop() === "flv") {
			_gaq.push(['_trackEvent', 'Playback', 'InitializeFlash']);
			JVideoPlayer.registerswfetc();
		} else {
			var videoTag = document.createElement('video');
			_gaq.push(['_trackEvent', 'Playback', 'InitializeHTML5']);
			if (!videoTag.canPlayType && (!videoTag.canPlayType('video/mp4') || !videoTag.canPlayType('video/webm'))) {
				_gaq.push(['_trackEvent', 'Playback', 'MP4_WEBM_Not_Supported', 'HTML5 support. But cant play mp4, webM']);
				JVideoPlayer.registerswfetc();
			} else {
				JVideoPlayer.createVideoTag();
			}
		}
	};

	$.fn.JVideoPlayer = function(options) {
		var vidPlayerObject = $(this).data('JVideoPlayer');
		var element = $(this);
		//If its a new video that needs to be instantiated but if a video player already exisits
		if (options.newTag === true && vidPlayerObject) {
			//If its HTML5 based playback, handle differently
			if (vidPlayerObject.html5 === true) {
				_gaq.push(['_trackEvent', 'Playback', 'RemoveOldPlayer', 'Player already exists. Deleting. Possibly due to next clip functionality']);
				vidPlayerObject.removeEventsHTML5();
				$(this).removeData('JVideoPlayer');
				vidPlayerObject = null;
			} else {
				//This is done because of a weird bug of display:none because of which we cannot use the
				//setMediaResourceURL on the player object. As a result, the swf has to be unloaded completely
				//and player needs to be created again. This will happen only in the case of system test playback.
				if (options.changeSrcDisplayNone === true) {
					vidPlayerObject.deregisterswf();
					$(this).removeData('JVideoPlayer');
					vidPlayerObject = null;
				//If Source is changed in flash(when clicking through thumbnails in playback of practice interviews)
				} else if (options.changeSrc === true) {
					//If vidPlayerObject is set and its flash object, the following will be set for sure.
					vidPlayerObject.players[options.id].player.setMediaResourceURL(options.src[0]);
					options.changeSrc = false;
				}
			}
			options.newTag = false;
		}
		return this.each(function() {
            if (vidPlayerObject) {
               return;
            }

			var JVidPlayer = new JVideoPlayerPlugin(this, options);
			element.data('JVideoPlayer', JVidPlayer);
		});
	};
})(jQuery);
